import { Component, OnInit, Renderer2, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { TCCPLocalStorageService } from '../../services/tccp-local-storage.service';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { TCCPConstantValues } from '../../../shared/models/tccp-constants';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public envName = '';
  public appName = '';
  public routerPath = '';
  public logoPath = '';
  public isDesktopView = false;
  public styleList = ['./header.component.scss'];

  public underlineText = false;
  public mockData = {};
  public config = {};
  public title = null;
  public isInternal = false;
  public windowWidth: number;

  constructor(
    private router: Router, private storageService: TCCPLocalStorageService,
    public commonService: TCCPCommonService, public authService: MsalService) {
  }

  ngOnInit() {
    this.underlineText = false;
    this.windowWidth = window.innerWidth;
    const envName = window.location.href;
    if (envName.includes(TCCPConstantValues.base.url_contexts.TOYOTA_QUICKGUIDE)) {
      this.envName = TCCPConstantValues.base.url_contexts.TOYOTA_QUICKGUIDE;
    }
    if (envName.includes(TCCPConstantValues.base.url_contexts.LEXUS_QUICKGUIDE)) {
      this.envName = TCCPConstantValues.base.url_contexts.LEXUS_QUICKGUIDE;
    }
    this.appName = environment.applicationName;
    if (environment.applicationName === TCCPConstantValues.base.url_contexts.TOYOTA_QUICKGUIDE ||
      environment.applicationName === TCCPConstantValues.base.url_contexts.LEXUS_QUICKGUIDE) {
      this.appName = environment.applicationName;
      environment.applicationName = environment.applicationName === TCCPConstantValues.base.url_contexts.TOYOTA_QUICKGUIDE ? 'toyota' :
        environment.applicationName === TCCPConstantValues.base.url_contexts.LEXUS_QUICKGUIDE ? 'lexus' : environment.applicationName;
      this.appName = environment.applicationName === TCCPConstantValues.base.url_contexts.TOYOTA_QUICKGUIDE ? 'toyota' :
        environment.applicationName === TCCPConstantValues.base.url_contexts.LEXUS_QUICKGUIDE ? 'lexus' : environment.applicationName;
    }
    this.routerPath = this.appName + '/home';
    this.logoPath = this.storageService.getFeatureType() ? `${this.appName}/home/internal` : `${this.appName}/home`;
    this.isDesktopView = window.innerWidth > 1200 ? true : false;
    /* Block Added for TCCP-928 */
    this.isInternal = this.commonService.setAppFeatureType(this.router.url);

  }

  public onLogoClick() {
    this.storageService.clearStorage();
  }

  onLogout() {
    this.authService.logout();
  }

  onResize(event) {
    this.isDesktopView = window.innerWidth > 1200 ? true : false;
  }


}

